export const environment = {
  APP_NAME: 'Inforelay',
  API_BASE_URL: 'https://api.tvmaze.com',
  API_MOVIES_URL: '/search/shows',
  API_MOVIE_URL: '/shows',
  DEFAULT_SEARCH_MOVIE: 'actu',
  MOVIE_PLACEHOLDER_URL: window.origin + '/article-placeholder.jpg',
  API_BASE_URL_INF: 'https://covidrelaiapi.herokuapp.com',
  API_NOTIFS_URL_NOTIFICATIONS: '/api/notifications',
};
